import React from "react";
import { AlertOctagon, AlertTriangle, Info } from "lucide-react";

const styles = {
  critico: {
    bg: "bg-red-50",
    text: "text-red-900",
    border: "border-red-200",
    icon: <AlertOctagon className="h-3.5 w-3.5 text-red-600" strokeWidth={2.5} />,
    label: "Critico",
  },
  alto: {
    bg: "bg-orange-50",
    text: "text-orange-900",
    border: "border-orange-200",
    icon: <AlertTriangle className="h-3.5 w-3.5 text-orange-600" strokeWidth={2.5} />,
    label: "Alto",
  },
  normale: {
    bg: "bg-slate-50",
    text: "text-slate-700",
    border: "border-slate-200",
    icon: <Info className="h-3.5 w-3.5 text-slate-500" strokeWidth={2.5} />,
    label: "Normale",
  },
};

export default function UrgencyBadge({ urgency, className = "" }) {
  const s = styles[urgency] || styles.normale;
  return (
    <span
      data-testid={`urgency-badge-${urgency}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-bold uppercase tracking-wide border ${s.bg} ${s.text} ${s.border} ${className}`}
    >
      {s.icon}
      {s.label}
    </span>
  );
}
